<cs-header>
  <cs-header-title>{{ title }}</cs-header-title>
  <cs-note light>{{ description }}</cs-note>
</cs-header>

<cs-content [no-scroll]="true">
  <cs-textarea [value]="noteText" (valueChange)="onNoteChange($event)" [placeholder]="placeholder"
    [rows]="8"></cs-textarea>

</cs-content>
<cs-page-action-buttons [showCancel]="true" (cancel)="onCancelClick($event)">
  <cs-button medium primary [label]="LL.common.buttons.save()" (click)="onSaveClick()"></cs-button>
</cs-page-action-buttons>